import concatClass from "discourse/helpers/concat-class";
import SelectedNameComponent from "select-kit/components/selected-name";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class SelectedFont extends SelectedNameComponent {
  static {
    setComponentTemplate(precompileTemplate("\n    <span class={{concatClass \"name\" this.item.classNames}}>\n      {{this.label}}\n    </span>\n  ", {
      strictMode: true,
      scope: () => ({
        concatClass
      })
    }), this);
  }
}